export default {"src":"/_next/static/media/logo_white.b3262349.svg","height":33,"width":89,"blurWidth":0,"blurHeight":0};